module.exports = "/_next/static/images/d89e8a8e563d5fe37aedb759219dc868-forbes.png.webp";